module.exports = __webpack_public_path__ + "static/feature-distribution-7871b64dddb7fbfb3c5c9e3f2f8458c6.png";